import React from "react"
import styled from "styled-components"
import { breakpoints } from "../../../theme"
import { ArrowSelect } from "@bw/icons"

const StyledSelect = styled.select`
  opacity: 0.5;
  font-family: var(--font);
  font-weight: 400;
  font-size: 14px;
  line-height: 189.3%;
  letter-spacing: 0.055em;
  background: none;
  border: none;
  height: 35px;
  width: 100%;
  margin: ${props => props.margin};
  -webkit-appearance: none;

  @media (min-width: ${breakpoints.medium}px) {
    font-size: 16px;
  }
  &:focus {
    opacity: 1;
    outline: none;
  }
  &[readonly] {
    cursor: not-allowed;
    background-color: #ddd;
  }
`

const Border = styled.div`
  border-bottom: 1px solid #000;
  width: 100%;
  display: grid;
  gap: 10px;
  margin-top: 10px;
  align-items: center;
  grid-template-columns: 1fr auto;
  position: relative;

  :nth-child(2) {
    position: relative;
    padding-right: 15px;
    &:after {
      content: "";
      display: block;
      height: 40%;
      width: 1px;
      top: 20%;
      right: 50px;
      position: absolute;
      transform: translateY(10%);
      background: rgba(4, 6, 44, 0.3);
    }
`

const Select = ({ field, form, icon, ...props }) => {
  return (
    <Border>
      <StyledSelect {...field} {...props} data-cy={field?.name || props?.name}>
        {props.children}
      </StyledSelect>
      <ArrowSelect />
    </Border>
  )
}

export { Select }
